import { render, staticRenderFns } from "./exchangeCurrencyTicketVoucherDetail.vue?vue&type=template&id=6b2b047b&lang=pug"
import script from "./exchangeCurrencyTicketVoucherDetail.vue?vue&type=script&lang=js"
export * from "./exchangeCurrencyTicketVoucherDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports